import { useContext } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import NoFilter from "../../../../DataTable/datatable.nofilter";
import { LotDetailContext } from "../../../../Contexts/LotDetailContext";

export function URLColumn() {
    const {
        lotFlags: {
            showSpecsWithReleaseLimits
        }
    } = useContext(LotDetailContext);

    return {
        Header: 'URL',
        accessor: 'upperReleaseLimit',
        Filter: NoFilter,
        Cell: ({ row, value }: any) => {
            if (value === null) {
                return showSpecsWithReleaseLimits ? <span>{row.original.max}</span> : <></>;
            }

            if (showSpecsWithReleaseLimits) {
                return (
                    <OverlayTrigger overlay={<Tooltip>Sales limit: {row.original.max}</Tooltip>}>
                        <span>{value}</span>
                    </OverlayTrigger>
                );
                
            }

            return <span>{value}</span>;
        }
    };
}
